import EmblaCarousel from 'embla-carousel'
import A11y from '@bluecadet/embla-carousel-a11y'
import { openModal } from '../modal.js'
import { initCarouselInert } from '../carousel/carouselInert.js'
import { reducedMotion } from '../../utils/breakpoints.js'

const init = () => {
    const gallery = document.querySelector('[data-dev-gallery]')
    if (!gallery) return

    const viewport = gallery.querySelector('[data-gallery-viewport]')
    if (!viewport) return

    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')]
    const prevBtn = gallery.querySelector('[data-carousel-prev]')
    const nextBtn = gallery.querySelector('[data-carousel-next]')

    const embla = EmblaCarousel(viewport, { loop: true, duration: reducedMotion.matches ? 0 : 25 }, [A11y()])
    initCarouselInert(embla)

    const updateThumbs = () => {
        const total = embla.slideNodes().length
        if (!thumbs.length || total < 2) return
        const current = embla.selectedScrollSnap()
        const visibleCount = Math.min(2, total - 1)
        thumbs.forEach((thumb) => thumb.classList.add('hidden'))
        for (let i = 1; i <= visibleCount; i++) {
            thumbs[(current + i) % total]?.classList.remove('hidden')
        }
    }

    prevBtn?.addEventListener('click', () => embla.scrollPrev())
    nextBtn?.addEventListener('click', () => embla.scrollNext())

    const updateNav = () => {
        const scrollable = embla.canScrollPrev() || embla.canScrollNext()
        prevBtn?.classList.toggle('hidden', !scrollable)
        nextBtn?.classList.toggle('hidden', !scrollable)
    }

    embla.on('init', updateThumbs)
    embla.on('init', updateNav)
    embla.on('select', updateThumbs)
    embla.on('reInit', updateThumbs)
    embla.on('reInit', updateNav)

    // ── Modal gallery ────────────────────────────────────────────
    const modalSource = gallery.querySelector('[data-gallery-modal-source]')
    const galleryTrigger = document.querySelector('[data-gallery-trigger]')
    const slideButtons = [...gallery.querySelectorAll('[data-gallery-slide-btn]')]

    if (!modalSource) return

    let modalEmbla = null

    const openAt = (index, triggerEl) => {
        openModal(modalSource, {
            trigger: triggerEl,
            onShow: (modal) => {
                const modalViewport = modal.querySelector('[data-gallery-modal-viewport]')
                if (!modalViewport) return

                modalEmbla = EmblaCarousel(modalViewport, { loop: true, duration: reducedMotion.matches ? 0 : 25 }, [A11y()])

                const modalPrev = modal.querySelector('[data-carousel-prev]')
                const modalNext = modal.querySelector('[data-carousel-next]')
                const countEl = modal.querySelector('[data-carousel-count]')

                const updateCount = () => {
                    if (!countEl) return
                    const total = modalEmbla.slideNodes().length
                    const current = modalEmbla.selectedScrollSnap() + 1
                    countEl.textContent = `${current} / ${total}`
                }

                modalPrev?.addEventListener('click', () => modalEmbla.scrollPrev())
                modalNext?.addEventListener('click', () => modalEmbla.scrollNext())

                modalEmbla.on('init', updateCount)
                modalEmbla.on('select', updateCount)
                modalEmbla.on('reInit', updateCount)

                requestAnimationFrame(() => {
                    modalEmbla.reInit()
                    modalEmbla.scrollTo(index, true)
                })
            },
            onClose: () => {
                if (modalEmbla) {
                    modalEmbla.destroy()
                    modalEmbla = null
                }
            },
        })
    }

    galleryTrigger?.addEventListener('click', () => {
        openAt(embla.selectedScrollSnap(), galleryTrigger)
    })

    slideButtons.forEach((btn, i) => {
        btn.addEventListener('click', () => openAt(i, btn))
    })

    thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => openAt(i, thumb))
    })
}

init()